import React, { useState, useEffect } from "react";
import { Button, Card, Col, Form, Input, message, PageHeader, Row, Spin } from "antd";
import { DollarOutlined } from "@ant-design/icons";
import CustomBtn from "../../../components/Button";
import { useDispatch, useSelector } from "react-redux";
import { useBillOrbusGetMutation, useBillFeesMutation, useBillOrbusPayMutation } from "../../../redux/bills/bill-orbus-api";
import PinCodeDialog from "../../../components/Dialog/pincode-dialog";
import { showDialog } from "../../../redux/dialog/dialog-slice";
import { handleApiError } from "../../../utils/errorHandler";


export function BillOrbusPage(param) {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const { currentAgent } = useSelector((state) => state.auth);
    const [ifFound, setIfFound] = useState(false);
    const [currentCollecte, setCurrentCollecte] = useState({});
    const [billGetInfo] = useBillOrbusGetMutation();
    const [show, setShow] = useState(false);
    const [frais, setFrais] = useState([]);
    const dialog = useSelector((state) => state.dialog);
    const [isLoading, setIsLoading] = useState(false);
    const [billFees] = useBillFeesMutation();
    const [billOrbusPay] = useBillOrbusPayMutation();
    const [paidFor, setPaidFor] = useState();

    const handleTransaction = async (value) => {
        setIsLoading(true);
        const data = {
            "type": "ORBUS",
            "pincode": "",
            "country": currentAgent.country,
            "code_jeton": value.number_card.toUpperCase(),
            "token": currentAgent.access_token,
        }
        billGetInfo(data)
            .unwrap()
            .then((res) => {
                setIsLoading(false);
                setIfFound(true);
                setCurrentCollecte(res.result);
                form.setFieldsValue({
                    amount: res.result.montant,
                });
            })
            .catch((error) => {
                setIsLoading(false);
                message.error(error.data.error ?? error.data.message);
            });
    }


    const handleFees = async (value) => {
        setIsLoading(true);
        const data = {
            operation: "ORBUS",
            receiver: currentAgent.country === "sn" ? "60600" : "60500",
            montant: value.amount,
            country: currentAgent.country,
            pincode: "",
            token: currentAgent.access_token,
        };
        billFees(data)
            .unwrap()
            .then((res) => {
                setIsLoading(false);
                setFrais(res);
                setPaidFor(value.paid_for)
                dispatch(showDialog({ isPinCode: true }))
                setShow(true);
            })
            .catch((error) => {
                // console.log(error.data.status);
                setIsLoading(false);
                if ((error.data.status === "TOKEN_EXPIRED") || (error.data.status === "Unauthorized"))
                    dispatch(showDialog({ isLockscreen: true }));
                else {
                    setIfFound(false);
                    form.resetFields();
                    dispatch(showDialog({ isError: true, errorMessage: handleApiError(error.data) }));
                }
            });
    };

    const handlePay = async (pin) => {
        setIsLoading(true);
        setShow(false);
        const data = {
            code_jeton: currentCollecte.code_jeton,
            amount: currentCollecte.montant,
            pincode: pin,
            country: currentAgent.country,
            paid_for: paidFor,
            token: currentAgent.access_token,
        };
        //console.log(data);
        billOrbusPay(data)
            .unwrap()
            .then((res) => {
                setCurrentCollecte([]);
                setIsLoading(false);
                dispatch(showDialog({ isSuccess: true, successMessage: "Transaction effectuée avec succès" }));
                setIfFound(false);
                form.resetFields();
            })
            .catch((error) => {
                setIsLoading(false);
                if ((error.data.status === "TOKEN_EXPIRED") || (error.data.status === "Unauthorized"))
                    dispatch(showDialog({ isLockscreen: true }));
                else
                    dispatch(showDialog({ isError: true, errorMessage: handleApiError(error.data) }));
            });
    };

    const getPin = (pin) => handlePay(pin);

    const resumeJson = {
        "title": `Recharge ${param.param}`,
        "message": `Vous allez payer la facture numéro ${currentCollecte.reference} d'un montant de ${currentCollecte.montant} FCFA .`,
        "fees": frais.fees
    }

    return (
        <div className="default-page">
            {dialog.isPinCode && <PinCodeDialog resume={resumeJson} pinCode={getPin} />}
            <PageHeader title={`Recharge ${param.param}`} />
            <Spin tip="Chargement..." spinning={isLoading}>
                <Row gutter={20}>
                    <Col lg={18} xs={24}>
                        <Card>
                            <Form
                                name="basic"
                                form={form}
                                layout="vertical"
                                initialValues={{ remember: true }}
                                onFinish={ifFound ? handleFees : handleTransaction}>
                                <Form.Item
                                    label="Numero de carte"
                                    name="number_card"
                                    rules={[{ required: true, message: "Veuillez saisir un numéro" }]}>
                                    <Input
                                        className="form-control"
                                        placeholder="Numero de référence client"
                                    />
                                </Form.Item>
                                {ifFound && (
                                    <div>
                                        <Form.Item
                                            label="Montant"
                                            name="amount"
                                            rules={[{ pattern: new RegExp("^[0-9]+$"), message: "Montant incorrect" }, { required: true, message: 'Veuillez saisir un montant' }]}>
                                            <Input
                                                className="form-control"
                                                prefix={<DollarOutlined />}
                                                placeholder="Montant" />
                                        </Form.Item>

                                        <Form.Item
                                            label="Numero du client"
                                            name="paid_for"
                                            rules={[{ required: true, message: "Veuillez saisir un numéro client" }]}>
                                            <Input
                                                className="form-control"
                                                placeholder="Numero du client"
                                            />
                                        </Form.Item>
                                    </div>
                                )}
                                <Form.Item>
                                    <CustomBtn title={ifFound ? "Valider" : "Chercher"} />
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Spin>
        </div>
    );
}
export default BillOrbusPage;